module.exports = __webpack_public_path__ + "fonts/Vonnes-Bold.38bce0f0.otf";